import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchOrder, updateOrder } from '../store/slices/orderSlice';

export default function EditOrder() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { order, isLoading, message } = useSelector(s => s.orders);
  const [form, setForm] = useState({ companyName: '', customerName: '', totalAmount: '', orderDate: '', shipDate: '', paymentMethod: '', shipVia: '' });

  useEffect(() => { if (id) dispatch(fetchOrder(id)); }, [dispatch, id]);
  useEffect(() => {
    if (order) {
      setForm({
        companyName: order.companyName || '',
        customerName: order.customerName || '',
        totalAmount: order.totalAmount ?? '',
        orderDate: order.orderDate ? new Date(order.orderDate).toISOString().split('T')[0] : '',
        shipDate: order.shipDate ? new Date(order.shipDate).toISOString().split('T')[0] : '',
        paymentMethod: order.paymentMethod || '',
        shipVia: order.shipVia || '',
      });
    }
  }, [order]);

  const onChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      companyName: form.companyName || undefined,
      customerName: form.customerName || undefined,
      totalAmount: form.totalAmount !== '' ? Number(form.totalAmount) : undefined,
      orderDate: form.orderDate || undefined,
      shipDate: form.shipDate || undefined,
      paymentMethod: form.paymentMethod || undefined,
      shipVia: form.shipVia || undefined,
    };
    await dispatch(updateOrder({ id, payload })).unwrap().catch(()=>{});
    navigate(`/orders/${id}`);
  };

  if (isLoading && !order) return <div>Loading...</div>;
  if (!order) return <div>Not found</div>;

  return (
    <div className="page">
      <h2>Edit Order #{order.orderNumber || '-'}</h2>
      {message && <div className="error">{message}</div>}
      <form onSubmit={onSubmit} style={{ display: 'grid', gap: 12, maxWidth: 480 }}>
        <label>
          Company Name
          <input name="companyName" value={form.companyName} onChange={onChange} />
        </label>
        <label>
          Customer Name
          <input name="customerName" value={form.customerName} onChange={onChange} />
        </label>
        <label>
          Total Amount
          <input type="number" step="0.01" name="totalAmount" value={form.totalAmount} onChange={onChange} />
        </label>
        <label>
          Order Date
          <input type="date" name="orderDate" value={form.orderDate} onChange={onChange} />
        </label>
        <label>
          Ship Date
          <input type="date" name="shipDate" value={form.shipDate} onChange={onChange} />
        </label>
        <label>
          Payment Method
          <input name="paymentMethod" value={form.paymentMethod} onChange={onChange} placeholder="Credit Card" />
        </label>
        <label>
          Ship Via
          <input name="shipVia" value={form.shipVia} onChange={onChange} placeholder="UPS Ground" />
        </label>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="submit">Save</button>
          <button type="button" onClick={()=>navigate(`/orders/${id}`)}>Cancel</button>
        </div>
      </form>
    </div>
  );
}
